module.exports = "/src/views/player/hudevo/ipad/assets/images/radio.png";